import { render, staticRenderFns } from "./NextBackButtons.vue?vue&type=template&id=28eebd03&scoped=true&"
import script from "./NextBackButtons.vue?vue&type=script&lang=js&"
export * from "./NextBackButtons.vue?vue&type=script&lang=js&"
import style0 from "./NextBackButtons.vue?vue&type=style&index=0&id=28eebd03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eebd03",
  null
  
)

export default component.exports